export default __webpack_public_path__ + "1af7128917b5e3011076340f4dc8b676.svg";